// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { KeycloakConfig } from 'keycloak-angular';

// let keycloakConfig: KeycloakConfig = {
//   url: 'https://www.ifincloud.io/auth',//'http://localhost:8090/auth',
//   realm: 'CBXR_BackOffice_New_Age_Digital_Banking_Experience',//'backoffice',
//   clientId: 'BackOfficeLogin'//'backoffice-login'
//   // url: 'http://10.11.12.24:20692/auth', //http://15.207.26.223:10042/auth
//   // realm: 'Concentra', //Concentra, QCBXPortal
//   // clientId: 'PortalLogin', //cbxr-login, PortalLogin
// };

export const environment = {
  production: false,
  shortNotification : true,
  // orgin: 'http://localhost:4200',
  // baseURL: 'http://172.16.103.134:10280',
  // baseURL: 'http://10.11.12.31:10024',
  // defaultContext:'/olive/publisher',
  //baseURL: 'http://10.11.12.24:20663',
  // keycloak: keycloakConfig,
  configFile: 'assets/config/config.json',  
  constantFile: 'assets/config/constants.json',
  appResourceFile: 'assets/config/application.resource.json',
  olive_publisher:'/olive/publisher',
  domainObject_context:'/olive',
  cbx_common_publisher:'/cbx-common/publisher',
  cbx_accounts_publisher:'/olive/publisher',
  cbx_transfers_publisher:'/olive/publisher',
  cbx_deposits_publisher:'/olive/publisher',
  cbx_mock_publisher:'/olive/publisher',
  cbx_customers_publisher:'/olive/publisher',
  count:20
  // fileUploadURL:'https://www.ifincloud.io/cbx-common/publisher'
};

/*
 * In development mode, for easier debugging, you can ignore zone related error
 * stack frames such as `zone.run`/`zoneDelegate.invokeTask` by importing the
 * below file. Don't forget to comment it out in production mode
 * because it will have a performance impact when errors are thrown
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

